import { BarceloComponent } from "components-utils";

const AllBrhComposition = {
  brhBannerDecorative: BarceloComponent({
    selector: ".brh-banner-decorative, .brh-banner-decorative-dl-id",
    path: "brh/composition/brh-banner-decorative/js/brh-banner-decorative",
    ignoreViewport: true,
  }),

  brhBannerQuote: BarceloComponent({
    selector: ".brh-banner-quote, .brh-banner-quote-dl-id",
    path: "brh/composition/brh-banner-quote/js/brh-banner-quote",
  }),

  brhBannerShowcase: BarceloComponent({
    selector: ".brh-banner-showcase, .brh-banner-showcase-dl-id",
    path: "brh/composition/brh-banner-showcase/js/brh-banner-showcase",
  }),

  brhBookMeetingRooms: BarceloComponent({
    selector: ".brh-book-meeting-rooms, .brh-book-meeting-rooms-dl-id",
    path: "brh/composition/brh-book-meeting-rooms/js/brh-book-meeting-rooms",
  }),

  brhCampaignList: BarceloComponent({
    selector: ".brh-campaign-list, .brh-campaign-list-dl-id",
    path: "brh/composition/brh-campaign-list/js/brh-campaign-list",
  }),

  brhCollage: BarceloComponent({
    selector: ".brh-collage, .brh-collage-dl-id",
    path: "brh/composition/brh-collage/js/brh-collage",
  }),

  brhCompositionActivities: BarceloComponent({
    selector: ".brh-composition-activities, .brh-composition-activities-dl-id",
    path: "brh/composition/brh-composition-activities/js/brh-composition-activities",
  }),

  brhCompositionActivitiesItem: BarceloComponent({
    selector: ".brh-composition-activities-item, .brh-composition-activities-item-dl-id",
    path: "brh/composition/brh-composition-activities-item/js/brh-composition-activities-item",
  }),

  brhCompositionAwards: BarceloComponent({
    selector: ".brh-composition-awards, .brh-composition-awards-dl-id",
    path: "brh/composition/brh-composition-awards/js/brh-composition-awards",
  }),

  brhCompositionCards: BarceloComponent({
    selector: ".brh-composition-cards, .brh-composition-cards-item__wrapper, .brh-composition-cards-dl-id",
    path: "brh/composition/brh-composition-cards/js/brh-composition-cards",
  }),

  brhCompositionCardsItem: BarceloComponent({
    selector: ".brh-composition-cards-item, .brh-composition-cards-item__wrapper, .brh-composition-cards-item-dl-id",
    path: "brh/composition/brh-composition-cards-item/js/brh-composition-cards-item",
  }),

  brhCompositionContent: BarceloComponent({
    selector: ".brh-composition-content, .brh-composition-content-dl-id",
    path: "brh/composition/brh-composition-content/js/brh-composition-content",
  }),

  brhCompositionMultifunctional: BarceloComponent({
    selector: ".brh-composition-multifunctional, .brh-composition-multifunctional-dl-id",
    path: "brh/composition/brh-composition-multifunctional/js/brh-composition-multifunctional",
  }),

  brhCompositionFaqs: BarceloComponent({
    selector: ".brh-composition-faqs, .brh-composition-faqs-dl-id",
    path: "brh/composition/brh-composition-faqs/js/brh-composition-faqs",
  }),

  brhCompositionRestaurant: BarceloComponent({
    selector: ".brh-composition-restaurant, .brh-composition-restaurant-dl-id",
    path: "brh/composition/brh-composition-restaurant/js/brh-composition-restaurant",
  }),

  brhFaqs: BarceloComponent({
    selector: ".brh-faqs, .brh-faqs-dl-id",
    path: "brh/composition/brh-faqs/js/brh-faqs",
  }),

  brhOfferCard: BarceloComponent({
    selector: ".brh-offer-card, .brh-offer-card-dl-id",
    path: "brh/composition/brh-offer-card/js/brh-offer-card",
  }),

  brhOfferLauncher: BarceloComponent({
    selector: ".brh-offer-launcher, .brh-launcher, .brh-offer-launcher-dl-id",
    path: "brh/composition/brh-offer-launcher/js/brh-offer-launcher",
  }),

  brhPictures: BarceloComponent({
    selector: ".brh-pictures, .brh-pictures-dl-id",
    path: "brh/composition/brh-pictures/js/brh-pictures",
  }),

  brhRoomDetail: BarceloComponent({
    selector: ".brh-room-detail, .brh-room-detail-dl-id",
    path: "brh/composition/brh-room-detail/js/brh-room-detail",
  }),

  brhTripadvisorReviews: BarceloComponent({
    selector: ".brh-tripadvisor-reviews, .brh-tripadvisor-reviews-dl-id",
    path: "brh/composition/brh-tripadvisor-reviews/js/brh-tripadvisor-reviews",
  }),

  brhCompositionCarousel: BarceloComponent({
    selector: ".brh-composition-carousel, .brh-composition-carousel-dl-id",
    path: "brh/composition/brh-composition-carousel/js/brh-composition-carousel",
  }),
};

export default AllBrhComposition;
